import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { getData } from "../../Service/ApiMethod";
// import { Count_Seekers, RECURITER_PROFILE } from "../../Service/service";
import UpdateLocation from "../../common/UpdateLocatioPopup";
import { useTranslation } from "react-i18next";
import { lang } from "../../lang";

const MyProfile = (props) => {
  
  // const [profile, setProfile] = useState();
  const [updateLocation, setUpdateLocation] = useState();
  // const [showMore, setShowMore] = useState()
  const [ln,setLn] = useState('en')
  const resData = props?.resData
  const navigate = useNavigate();

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const {t} = useTranslation()

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props?.closeModalWrtOutsideClick();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  function vaccancyNavRedirect() {
    navigate("/vaccancy");
  }
  function redirectUnlockedCandidates() {
    navigate("/unlock-profiles");
  }
  
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
        setLn(localStorage.getItem("language"))
      } 
  },[])


  // useEffect(() => {
  //   getDetail();
  // }, []);
  return (
    <div className='blur-screen-full-area flex-center' style={{ position: 'fixed', top: '0', zIndex: '999999999999999999999999', height: '100vh', background:'rgb(0, 0, 0, 0.5' }}>
    <div className="my-profile-container relative" ref={wrapperRef} onClick={props?.closePopup}>
      {/* <button className="btn-none close-popup-btn" onClick={props?.closePopup}>
        x
      </button> */}
      <div className="my-profile ">
        {resData !== undefined ? (
          <div className="users-info">
            {/* <img
              src="./images/pencilBlack.png"
              className="rightPositionTopImg"
              alt=""
            /> */}

            <div className="row">
              <div className="col-3 px-0 ">
                <div className="my-profile-userouter">
                <img
                  // src="./images/msg1.png"
                  src={
                  (resData?.image) || "./images/Vector.png"
                  } 
                  className="my-profile-user"
                  style={{}}

                  alt=""
                />
                </div>
            
              </div>

              <div className="col-9 pr-0 pl-1">
                <h3 className="user-name">
                  {" "}
                  {resData?.first_name} {resData?.last_name}{" "}
                </h3>
                <p className="text"> {resData?.user?.phone}</p>
                <p className="text"> {resData?.email}</p>
                <p className="text"> {resData?.user.user_types == "recruiter" || resData?.user.user_types == "jobseeker" ? "Admin":"Sub-User"}</p>
              </div>
            </div>
            <p className="myProfile-heading mt-3 mb-2">
              {" "}
              {resData?.company_name}
            </p>
            <p className="text mb-2">
              {" "}
              <img src="./images/earth.png" alt=""  className=" side-icon-small " />{" "}
              {resData?.company_website}
            </p>
            <p className="text">
              <img src="./images/location-black.png" alt=""  className="side-icon-smallocate" />{" "}
              {resData?.company_location}
            </p>
            <p className="myProfile-heading my-2">{t('About Company')}</p>
            <p className="text"
            style={{ textOverflow : 'ellipsis',

            whiteSpace: 'nowrap',

           overflow:'hidden'}}>
             {resData?.about_company}
            </p>
            
          </div>
        ) : null}

        {/* <div className="loginFirst">
            <div className="flex-center flex-column">
                <h2 className="heading">Welcome To Catch-Up</h2>
                <Link to="/" className="mt-4 link theme-btn btn-block w-75">Login</Link>

                <Link to="/" className="link mt-4">
                    <p className="text">Create An Account</p>
                </Link>
            </div>
        </div> */}

        <hr />
        <div className="">
        <div className="profiles-box">
        <Link to="/MainProfile" className="text text-link text-decoration-none">
            <div className="row horizontal-center" >
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img src="./images/user.png" alt="" className="side-icon"/>
                </div>
              </div>
              <div className="col">
                  {lang && Object.keys(lang).length > 0 ? lang[ln]?.tab['My Vacancies']:""}
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />
          {!(resData?.user?.user_types == 'sub_user') &&
          <>
          <div className="profiles-box">
          <Link to="/subcription" className="text text-link text-decoration-none">
            <div className="row horizontal-center">
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img className="side-icon" src="./images/subcription-bag.png" alt="" />
                </div>
              </div>
              <div className="col">
                  {lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['My Subcription']:""}
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />
          </>
          }
          
          <div className="profiles-box">
          <Link to="/mylists" className="text text-link text-decoration-none">
            <div className="row horizontal-center">
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img className="side-icon" src="./images/list.png" alt="" />
                </div>
              </div>
              <div className="col">
                  {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['My Lists']:""}
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />
          <div className="profiles-box">
          <Link to="/vaccancy" className="text text-link text-decoration-none">

            <div className="row horizontal-center" onClick={vaccancyNavRedirect}>
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img  src="./images/vaccancy-black.png" alt="" className="for-vacancy side-icon"/>
                </div>
              </div>
              <div className="col">
                
                  {lang && Object.keys(lang).length > 0 ? lang[ln]?.tab['My Vacancies']:""}
         
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />
          {/* <div className="profiles-box" onClick={() => setUpdateLocation(true)}>
            <div className="row horizontal-center">
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img src="./images/location_indicater.png" alt="" />
                </div>
              </div>
              <div className="col">
                <p className="text">Update Location</p>
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
          </div>
          <hr className="line" /> */}
          <div className="profiles-box">
          <Link to="/unlock-profiles" className="text text-link text-decoration-none">
            
            <div className="row horizontal-center" onClick={redirectUnlockedCandidates}>
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img src="./images/unlock-profile.png" alt="" className="for-unloacked"/>
                </div>
              </div>
              <div className="col">
                
                  {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['My Unlocked Candidates']:""}
                
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />
          {!(resData?.user?.user_types == 'sub_user') &&
          <>
          <div className="profiles-box">
          <Link to="/subusers" className="text text-link text-decoration-none">
            <div className="row horizontal-center">
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img className="side-icon" src="./images/sub-users.png" alt="" />
                </div>
              </div>
              <div className="col">
                  {t('Sub Users')}
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />
          </>
          }



{/* stored messges */}


<div className="profiles-box">
     <Link to="/recomended-msgs" className="text text-link text-decoration-none">
     <div className="row horizontal-center">
       <div className="col-2 px-0">
         <div
           className="p-2 bg-theme flex-center"
           style={{ borderRadius: "10px" }}
         >
           <img src="./images/MSG.png" alt="" 
           style={{height:'20px', width:'20px'}}
           />
         </div>
       </div>
       <div className="col">
       {t('Stored Messages')}
       </div>
       <div className="col-1 px-0 justify-content-end d-flex h-100">
         <img src="./images/go-arrow.png" alt="" />
       </div>
     </div>
     </Link>
   </div>
   
   <hr className="line" />


{!(resData?.login_type==='"social_login"') &&
  
  <>

<div className="profiles-box">
     <Link to="/jobseeker-settings" className="text text-link text-decoration-none">
     <div className="row horizontal-center">
       <div className="col-2 px-0">
         <div
           className="p-2 bg-theme flex-center"
           style={{ borderRadius: "10px" }}
         >
           <img className="side-icon" src="./images/settings.png" alt="" />
         </div>
       </div>
       <div className="col">
       {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['Settings']:""}
       </div>
       <div className="col-1 px-0 justify-content-end d-flex h-100">
         <img src="./images/go-arrow.png" alt="" />
       </div>
     </div>
     </Link>
   </div>
   
   <hr className="line" />
  </>
            
            }
       

          {/* <div className="profiles-box">
            <div className="row horizontal-center">
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: '10px' }}
                >
                  <img src="./images/bell-black.png" alt="" />
                </div>
              </div>
              <div className="col">
                <p className="text">Alerts/Notifications</p>
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
          </div>
          <hr className="line" /> */}

          <div className="profiles-box">
          <Link to="/privacy_policies" className="text text-link text-decoration-none">
            <div className="row horizontal-center">
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img className="side-icon" src="./images/guard.png" alt="" />
                </div>
              </div>
              <div className="col">
                {t('Privacy & Policies')}
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />

          <div className="profiles-box">
          <Link to="/contact-support" className="text text-link text-decoration-none">
            <div className="row horizontal-center">
              <div className="col-2 px-0">
                <div
                  className="p-2 bg-theme flex-center"
                  style={{ borderRadius: "10px" }}
                >
                  <img className="side-icon" src="./images/contact.png" alt="" />
                </div>
              </div>
              <div className="col">
                  {t('Contact Support')}
              </div>
              <div className="col-1 px-0 justify-content-end d-flex h-100">
                <img src="./images/go-arrow.png" alt="" />
              </div>
            </div>
            </Link>
          </div>
          <hr className="line" />
          <div className="profiles-box">
            <div className="flex-center flex-column" onClick={(e)=>{
                // e.stopPropagation()
                localStorage.removeItem("catzapp_token")
                window.location.href = 'https://catzapp.com/';
              }}>
              <p  className="link theme-btn text-link btn-block w-75" style={{display:'flex', justifyContent:'center', padding:'12px', color:'white'}} >
                {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['Log Out']:""}
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* <div className="my-profile mt-2">
        <div className="profiles-box">
          <div className="row">
            <div className="col-2 px-0">
              <img src="./images/user.png" alt="" />
            </div>
            <div className="col">
              <p className="text">My Subcriptions</p>
            </div>
            <div className="col-1 px-0 justify-content-end d-flex">
              <img src="./images/go-arrow.png" alt="" />
            </div>
          </div>
        </div>
        <hr className="line" />
      </div> */}

      {updateLocation ? <UpdateLocation close= {()=> setUpdateLocation(false)}/> : null}
    </div>
    </div>
  );
};

export default MyProfile;
